import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const contabo = defineConnector({
  identifier: "contabo",
  name: "Contabo",
  tagLine: "Cloud hosting and VPS provider",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://api\\.contabo\\.com/.*",
  auth: customAuth("contabo"),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Contabo Customer Panel](https://my.contabo.com/api/details) and note your **Client ID** and **Client Secret** under the API section.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "secrets", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
        {
          kind: "input",
          label: "API user",
          required: true,
          placeholder: "you@example.com",
          target: { kind: "configuration", field: "apiUser" },
        },
        {
          kind: "input",
          label: "API password",
          required: true,
          target: { kind: "secrets", field: "apiPassword" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.contabo.com/v1/compute/instances",
  },
});
